/* DoubleDouble: add to cart without leaving the page, then show a small confirmation panel. */
(function () {
  if (window.__ddAtc) return;
  window.__ddAtc = true;

  var style = document.createElement('style');
  style.textContent =
    '#dd-atc{position:fixed;z-index:9999;left:12px;right:12px;bottom:calc(12px + env(safe-area-inset-bottom,0px));background:#fff;color:#000;border:1px solid #000;border-radius:.5rem;padding:14px;box-shadow:0 8px 30px rgba(0,0,0,.18);font:inherit;transform:translateY(20px);opacity:0;pointer-events:none;transition:transform .25s ease,opacity .25s ease}' +
    '#dd-atc.show{transform:none;opacity:1;pointer-events:auto}' +
    '@media(min-width:768px){#dd-atc{left:auto;right:20px;bottom:auto;top:90px;width:360px;transform:translateY(-10px)}}' +
    '#dd-atc .dd-head{display:flex;justify-content:space-between;align-items:center;text-transform:uppercase;margin-bottom:10px}' +
    '#dd-atc .dd-x{background:none;border:0;padding:0 4px;font-size:22px;line-height:1;cursor:pointer;color:inherit}' +
    '#dd-atc .dd-item{display:flex;gap:12px;align-items:center;margin-bottom:12px}' +
    '#dd-atc .dd-item img{width:56px;height:56px;object-fit:cover;flex:none}' +
    '#dd-atc .dd-sub{font-size:.85em;opacity:.7}' +
    '#dd-atc .dd-actions{display:grid;grid-template-columns:1fr 1fr;gap:8px}' +
    '#dd-atc .dd-actions a,#dd-atc .dd-actions button{width:100%;text-align:center;margin:0}' +
    '#dd-atc.err .dd-item,#dd-atc.err .dd-checkout,#dd-atc.err .dd-ship-slot{display:none}' +
    '#dd-atc.err .dd-actions{grid-template-columns:1fr}' +
    '.dd-loading{opacity:.6;pointer-events:none}';
  document.head.appendChild(style);

  var el, timer;
  function build() {
    if (el) return el;
    el = document.createElement('div');
    el.id = 'dd-atc';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="dd-head"><span class="dd-msg"></span><button type="button" class="dd-x" aria-label="Close">&times;</button></div>' +
      '<div class="dd-item"><img alt=""><div><div class="dd-title"></div><div class="dd-sub"></div></div></div>' +
      '<div class="dd-ship-slot"></div>' +
      '<div class="dd-actions"><a href="/checkout" class="button is-primary dd-checkout">Checkout &rarr;</a><button type="button" class="button is-blank dd-keep">Keep shopping</button></div>';
    document.body.appendChild(el);
    el.querySelector('.dd-x').addEventListener('click', hide);
    el.querySelector('.dd-keep').addEventListener('click', hide);
    el.addEventListener('mouseenter', function () { clearTimeout(timer); });
    el.addEventListener('touchstart', function () { clearTimeout(timer); }, { passive: true });
    return el;
  }
  function hide() { if (el) el.classList.remove('show'); clearTimeout(timer); }
  function show(item) {
    build();
    el.classList.remove('err');
    el.querySelector('.dd-msg').textContent = '✓ Added to cart';
    el.querySelector('.dd-title').textContent = item.product_title || item.title || '';
    var sub = [];
    if (item.variant_title && item.variant_title !== 'Default Title') sub.push(item.variant_title);
    /* coffee: the chosen grind is saved as a note (properties.Grind), so show that instead of the variant's grind */
    var props = item.properties || {};
    if (props.Grind) {
      sub = [];
      var ov = item.options_with_values;
      if (ov && ov.length) {
        ov.forEach(function (o) {
          if (String(o.name).toLowerCase() !== 'grind' && o.value && o.value !== 'Default Title') sub.push(o.value);
        });
      } else if (item.variant_title && item.variant_title.indexOf(' / ') > -1) {
        sub.push(item.variant_title.split(' / ')[0]);
      }
      sub.push(props.Grind);
    }
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (plan && plan.name) sub.push(plan.name);
    el.querySelector('.dd-sub').textContent = sub.join(' · ');
    var img = el.querySelector('.dd-item img');
    var src = (item.featured_image && item.featured_image.url) || item.image;
    if (src) { img.src = src; img.style.display = ''; } else { img.style.display = 'none'; }
    el.classList.add('show');
    clearTimeout(timer);
    timer = setTimeout(hide, 8000);
  }
  function showError(msg) {
    build();
    el.classList.add('err');
    el.querySelector('.dd-msg').textContent = msg || 'Could not add to cart';
    el.classList.add('show');
    clearTimeout(timer);
    timer = setTimeout(hide, 6000);
  }

  var busy = false;
  function add(form, btn) {
    if (busy || !form) return;
    busy = true;
    if (btn) btn.classList.add('dd-loading');
    var fd = new FormData(form);
    var idInput = form.querySelector('[name="id"]');
    if (!fd.get('id') && idInput) fd.set('id', idInput.value);
    if (!fd.get('quantity') && form.id) {
      var q = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
      if (q) fd.set('quantity', q.value);
    }
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message); return d; }); })
      .then(function (item) {
        var line = item.items ? item.items[0] : item;
        show(line);
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var c = document.getElementById('counter');
        if (c) c.setAttribute('data-count', cart.item_count);
        if (window.ddShipBar) window.ddShipBar.update(cart);
        if (window.CartJS && typeof CartJS.getCart === 'function') { try { CartJS.getCart(); } catch (e) {} }
      })
      .catch(function (e) { showError(e && e.message); })
      .then(function () {
        busy = false;
        if (btn) btn.classList.remove('dd-loading', 'loading');
      });
  }

  function isCartForm(f) { return f && f.getAttribute && (f.getAttribute('action') || '').indexOf('/cart/add') > -1; }

  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"], [type="submit"][name="add"]');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!isCartForm(form) || btn.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    add(form, btn);
  }, true);

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isCartForm(form)) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    add(form, form.querySelector('[name="add"]'));
  }, true);
})();
